module.exports = __webpack_public_path__ + "img/1131.29aa324e.gif";